module.exports = __webpack_public_path__ + "static/app-steps-enviar-recibir-1248px-fb3abd028f829deaf3773a538bd0df88.gif";